<!---
<ara-side-nav class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>
-->
<div class="page-content-wrapper">
	<div class="col-lg-12 col-md-12 col-sm-12 mobile-view">
	<ol class="breadcrumb bc-3"  >
		<li>
		  <a [routerLink]="'/home'">Home</a>
		</li>
		<li>
		  <a>Person On Board</a>
		</li>
		
	  </ol>
	<div class="inner-wrapper">
		<div class="sub-wrapper">
			<div class="col-lg-12 col-md-12 col-sm-12 middle-content">
				<h2 class="page-title">
					<i class="fa fa-desktop"></i>Check In/Out
				</h2>
				<div *ngIf="hasCamera" style="display: flex; justify-content: center; align-items: center;">
					<video muted playsinline style="width: 50%;"></video>
				</div>
			</div>
			<div class="section-wrapper">
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
					<input type="text" placeholder="Search" class="form-control search-obs" [(ngModel)]="searchText"
						(keyup.enter)="isOnline ? searchData(): $event.preventDefault">
					<button class="btn btn-primary primary-btn" (click)="isOnline ? searchData(): $event.preventDefault">
						<i class="fa fa-search search"></i>
					</button>
					<div class="clearfix"></div>
				</div>
				<div class="clearfix"></div>
			</div>
			<div class="clearfix"></div>
		</div>
	</div>
	<div class="clearfix"></div>
</div>
<p-dialog header="User Details" modal="modal"  [(visible)]="isShowPassDetails" closable="true" 
	closeIcon="pi pi-times">
	<div class="clearfix"></div>
	<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" class="checkinout-content">
		<img style="border: 1px solid black; margin: auto;" height="200" src="{{printPass}}" />
		<div class="clearfix"></div>
		<div class="margin-top-10">
			<div class="sub-section-wrapper">
				<span class="section-sub-title">{{ "OBSERVATION.LOCATION" | translate }}</span><span [style]="!((!POBPermission.POB_SecurityCheckInOut && !POBPermission.POB_Admin && !POBPermission.POB_Admin_Unit) || isDisabled || isCheckOutDisabled) ? 'display:none;':''" class="mandatory" >*</span>
				<p-dropdown [options]="locations" placeholder="Select" [(ngModel)]="selectedLocation"
					  [disabled]="(!POBPermission.POB_SecurityCheckInOut && !POBPermission.POB_Admin && !POBPermission.POB_Admin_Unit) || isDisabled"></p-dropdown>
			</div>
			<ara-exact-location [Location]="Location" (Output)="getLocation($event)"></ara-exact-location>
			<p-messages [(value)]="passWarning"></p-messages>
			<button class="btn btn-primary primary-btn button-submit"
				[disabled]="(!POBPermission.POB_SecurityCheckInOut && !POBPermission.POB_Admin && !POBPermission.POB_Admin_Unit) || isDisabled || isCheckInDisabled || !selectedLocation"
				(click)="checkIn('CheckIn')">CheckIn
			</button>
			<button class="btn btn-primary primary-btn button-reset"
				[disabled]="(!POBPermission.POB_SecurityCheckInOut && !POBPermission.POB_Admin && !POBPermission.POB_Admin_Unit) || isDisabled || isCheckOutDisabled"
				(click)="checkIn('CheckOut')">CheckOut
			</button>
			<button class="btn primary-btn button-back" value="Close" style="margin-left:10px;color:white;" (click)="close()"
				[disabled]="!POBPermission.POB_SecurityCheckInOut && !POBPermission.POB_Admin && !POBPermission.POB_Admin_Unit">
				<i class="fa fa-times"></i>Close</button>
		</div>
	</div>
</p-dialog>
<p-dialog header="User Details" modal="modal"  [(visible)]="isShowOffline" closable="true"
	closeIcon="pi pi-times">
	<p-header><i class="fa fa-times pull-right cursor-pointer" (click)="isShowPassDetails=false"></i></p-header>
	<button class="btn btn-primary primary-btn" [disabled]="!independentPermissions.POB_SecurityCheckInOut && !POBPermission.POB_Admin && !POBPermission.POB_Admin_Unit"
		(click)="checkIn('CheckIn')">CheckIn
	</button>
	<button class="btn btn-primary primary-btn" [disabled]="!independentPermissions.POB_SecurityCheckInOut && !POBPermission.POB_Admin && !POBPermission.POB_Admin_Unit"
		(click)="checkIn('CheckOut')">CheckOut
	</button>
</p-dialog>
</div>
<!-- End outer-box -->
<ara-alerts [alertType]="alertType" [confirmMessage]="confirmMessage" [successDetails]="successDetails"
	[errorDetails]="errorDetails" (okClicked)="onOkClicked()" (yesClicked)="onYesClickedForConfirmation()"
	(noClicked)="onNoClickedForConfirmation()"></ara-alerts>
